/**
 * Compare day/session labels from the live API (e.g. "Session 1" … "Session 10").
 * Plain localeCompare orders "Session 10" before "Session 2".
 */
export function compareLiveDayLabels(a: string, b: string): number {
  const parse = (s: string): [number, number] | null => {
    const m = s.match(/^(Session|Day)\s+(\d+)$/i);
    if (!m) return null;
    const kind = m[1].toLowerCase() === 'session' ? 0 : 1;
    return [kind, parseInt(m[2], 10)];
  };
  const pa = parse(a);
  const pb = parse(b);
  if (pa && pb) {
    if (pa[0] !== pb[0]) return pa[0] - pb[0];
    return pa[1] - pb[1];
  }
  return a.localeCompare(b);
}
